import { SingleSelectorFieldProps, SelectorField } from '@anytag/shared-molecules';
import { usePostsFilterOptions } from '../../Posts';
import { InfluencersFilterFormKeys } from '../schemaTypes';

export const PostSocialMediaField = (
  props: Omit<SingleSelectorFieldProps<InfluencersFilterFormKeys>, 'name' | 'options' | 'multiple'>
) => {
  const { socialMediaOptions } = usePostsFilterOptions();

  return (
    <SelectorField<InfluencersFilterFormKeys>
      name="socialMedia"
      clearable={false}
      options={socialMediaOptions}
      showAllOptions
      {...props}
    />
  );
};
